import React from 'react';

import { Spacing } from '@kezios/design-system';
import { ContainerProps, Stack } from '@mantine/core';

import { SectionHeader } from '../SectionHeader/SectionHeader';
import { SectionLayout } from '../SectionLayout/SectionLayout';
import { Item } from './Item/Item';

export type InfoSectionProps = {
  children: React.ReactElement<typeof Item>[];
  category?: string;
  title?: string;
  subtitle?: string;
} & Omit<ContainerProps, 'children'>;

export const InfoSectionLayout = ({
  children,
  category = undefined,
  title = undefined,
  subtitle = undefined,
  ...props
}: InfoSectionProps) => {
  return (
    <SectionLayout {...props}>
      <Stack gap={Spacing.s24}>
        {(title || category || subtitle) && (
          <SectionHeader
            category={category}
            title={title}
            subtitle={subtitle}
            titleComponent="h2"
          />
        )}
        {children}
      </Stack>
    </SectionLayout>
  );
};

InfoSectionLayout.Item = Item;
